export default "__VITE_ASSET__DrXBz67t__"